import { useEffect } from 'react'; 
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {

    const token = Cookies.get('auth_token');
    const navigate = useNavigate();


    const url = window.location.href;
    const pathname = url.substr(url.lastIndexOf('/') + 1); 
    
  
    useEffect(() => { 
        if(token == null){
            Cookies.set('redirect_url', `${process.env.PUBLIC_URL}/`+pathname); 
            navigate(`${process.env.PUBLIC_URL}/login`)
        }
    }, []);

    return children;
  
};

export default ProtectedRoute;
